import { css } from 'lit';
export default css `
  ::slotted(svg) {
    display: block;
    height: var(--amityeko-icon-size, var(--private-size));
    fill: var(--amityeko-icon-color, var(--private-color));
  }
`;
//# sourceMappingURL=styles.js.map